<!-- component for listing selectedchat messages -->
<template>
  <div class="flex-auto flex">
    <div v-if="messages.length" class="message-list flex-auto py2 px3">
      <MessageItem v-for="message in messages" :message="message" :chat="chat" v-bind:key="message.messageId"></MessageItem>
    </div>
  </div>
</template>

<script>
import MessageItem from '@/components/reception/MessageItem.vue';

export default {
    components: { MessageItem },
    props: {
      chat: Object,
      messages: Array,
    },
    watch: {
        'messages': function(val, oldVal) {
          this.$nextTick(function() {
            const elem = this.$el.firstChild;
            elem.scrollTop = elem.scrollHeight;
        });
      }
    },
};
</script>

<style scoped>
  .message-list {
    overflow-y: auto;
  }

</style>
